export const GET_BALANCE_UNIT = 'app/customers/get_balance-unit';
export const GET_BALANCE_UNIT_SUCCESS =
  'app/customers/get_balance-unit_success';
export const GET_BALANCE_UNIT_FAILURE =
  'app/customers/get_balance-unit_failure';
